// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InitialConsultation.css - Tabbed consultation interface */

.initial-consultation {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* Header Section */
.consultation-header {
  margin-bottom: 20px;
}

.consultation-header h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.consultation-header p {
  color: #6b7280;
  margin: 0 0 16px 0;
}

.usage-info {
  background: #f3f4f6;
  padding: 8px 16px;
  border-radius: 6px;
  display: inline-block;
}

.usage-text {
  font-size: 14px;
  font-weight: 500;
}

.usage-text.limit-reached {
  color: #dc2626;
}

/* Tab Navigation */
.tab-navigation {
  display: flex;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 20px;
}

.tab-button {
  background: none;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.tab-button:hover {
  color: #374151;
  background: #f9fafb;
}

.tab-button.active {
  color: #4f46e5;
  border-bottom-color: #4f46e5;
  background: #f9fafb;
}

/* Forms Controls */
.forms-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.controls-left {
  display: flex;
  gap: 20px;
  align-items: center;
}

.controls-right {
  display: flex;
  gap: 20px;
  align-items: center;
}

.filter-section,
.search-section,
.slider-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-section label,
.slider-section label {
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}

.filter-section select,
.search-section input {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
}

.search-section input {
  width: 250px;
}

.slider-section input[type="range"] {
  width: 120px;
}

.create-form-btn {
  background: #4f46e5;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.create-form-btn:hover:not(.disabled) {
  background: #4338ca;
}

.create-form-btn.disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Forms List */
.forms-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.form-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  margin-bottom: 8px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  transition: all 0.2s;
}

.form-list-item:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-color: #d1d5db;
}

.form-list-item span {
  font-size: 16px;
  color: #374151;
  font-weight: 500;
}

.view-details-btn {
  background: #10b981;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.view-details-btn:hover {
  background: #059669;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
}

.empty-state h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.empty-state p {
  color: #6b7280;
  margin: 0 0 24px 0;
}

.create-btn {
  background: #4f46e5;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.create-btn:hover {
  background: #4338ca;
}

/* Modal Form Styling */
.form-group {
  margin-bottom: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #374151;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.resume-textarea {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  min-height: 200px;
}

.form-group small {
  display: block;
  margin-top: 5px;
  color: #6b7280;
  font-size: 14px;
}

/* Consultation Modal - Wide Layout */
.consultation-modal {
  max-width: 650px !important;
  width: 90% !important;
  min-width: 550px;
}

.consultation-modal .modal-body {
  padding: 32px;
}

.consultation-modal .form-creation-content {
  width: 100% !important;
}

.consultation-modal form {
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  margin-bottom: 0 !important;
  gap: 0 !important;
}

.consultation-modal .form-group {
  margin-bottom: 24px;
  width: 100%;
}

.consultation-modal .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.consultation-modal .form-group input,
.consultation-modal .form-group select {
  width: 100%;
  max-width: 450px;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background: white;
}

.consultation-modal .form-group input:focus,
.consultation-modal .form-group select:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.consultation-modal .form-group input:hover,
.consultation-modal .form-group select:hover {
  border-color: #9ca3af;
}

.consultation-modal .form-help {
  display: block;
  margin-top: 6px;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.4;
}

/* Modal Form Actions */
.consultation-modal .form-actions {
  display: flex !important;
  gap: 16px;
  justify-content: flex-end !important;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
  flex-direction: row !important;
  width: 100% !important;
}

/* Polished View Details Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  animation: slideInUp 0.3s ease-out;
  position: relative;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.close-btn-alt {
  position: absolute;
  top: 16px;
  right: 16px;
  background: #f3f4f6;
  border: 2px solid #e5e7eb;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  color: #6b7280;
  transition: all 0.2s ease;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.close-btn-alt:hover {
  background: #ef4444;
  color: white;
  border-color: #dc2626;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.form-card {
  padding: 0;
  background: white;
}

.form-header {
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #f3f4f6;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.form-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  line-height: 1.4;
  word-break: break-word;
}

.form-status {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-status:before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  margin-right: 8px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.form-details {
  padding: 24px;
  background: white;
}

.form-details p {
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  font-size: 15px;
  line-height: 1.5;
}

.form-details p:last-child {
  margin-bottom: 0;
}

.form-details strong {
  color: #374151;
  font-weight: 600;
  min-width: 80px;
  margin-right: 12px;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-details span {
  color: #6b7280;
  font-weight: 500;
}

.form-actions {
  padding: 20px 24px 24px 24px;
  background: #f8fafc;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.copy-link-btn,
.view-submissions-btn,
.expire-btn {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
  justify-content: center;
}

.copy-link-btn {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.copy-link-btn:hover {
  background: linear-gradient(135deg, #2563eb, #1e40af);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

.view-submissions-btn {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.view-submissions-btn:hover {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
}

.expire-btn {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.expire-btn:hover {
  background: linear-gradient(135deg, #dc2626, #b91c1c);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4);
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .modal {
    width: 95%;
    max-width: none;
    margin: 20px;
  }
  
  .form-header {
    padding: 20px 20px 16px 20px;
  }
  
  .form-header h3 {
    font-size: 18px;
    padding-right: 40px;
  }
  
  .form-details {
    padding: 20px;
  }
  
  .form-details p {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .form-details strong {
    min-width: auto;
    margin-right: 0;
    font-size: 13px;
  }
  
  .form-actions {
    padding: 16px 20px 20px 20px;
    flex-direction: column;
  }
  
  .copy-link-btn,
  .view-submissions-btn,
  .expire-btn {
    width: 100%;
    min-width: auto;
  }
}

.btn-primary,
.btn-secondary {
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.consultation-modal .btn-primary {
  background: #10b981 !important;
  color: white !important;
  border: none !important;
}

.consultation-modal .btn-primary:hover {
  background: #059669 !important;
}

.btn-secondary {
  background: white;
  color: #374151;
  border: 1px solid #d1d5db;
}

.btn-secondary:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

/* Responsive Design */
@media (max-width: 768px) {
  .consultation-controls {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .controls-left,
  .controls-right {
    flex-direction: column;
    gap: 12px;
  }
  
  .search-section input {
    width: 100%;
  }
  
  .forms-grid {
    grid-template-columns: 1fr;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
  
  .initial-consultation {
    padding: 10px;
  }
  
  .consultation-modal .form-actions {
    flex-direction: column !important;
  }
  
  .consultation-modal {
    min-width: auto !important;
    width: 95% !important;
    max-width: 95% !important;
  }
  
  .consultation-modal .modal-body {
    padding: 20px;
  }
  
  .consultation-modal .form-group {
    margin-bottom: 20px;
  }
  
  .consultation-modal .form-group input,
  .consultation-modal .form-group select {
    font-size: 16px; /* Prevent zoom on iOS */
    max-width: 100%; /* Full width on mobile */
  }
}

.initial-consultation__firm-link {
  margin-top: 32px;
}

.firm-link-card {
  border-radius: 16px;
  background: #ffffff;
  padding: 20px 24px;
  box-shadow: 0 12px 40px -20px rgba(15, 23, 42, 0.4);
}

.firm-link-header h3 {
  margin: 0;
  color: #0f172a;
}

.firm-link-header p {
  margin: 6px 0 18px;
  color: #475569;
}

.firm-link-loading,
.firm-link-error {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #475569;
}

.firm-link-url {
  display: flex;
  gap: 10px;
  align-items: center;
}

.firm-link-url input {
  flex: 1 1;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #cbd5f5;
  background: #f8fafc;
}

.firm-link-url button {
  padding: 10px 16px;
  border-radius: 10px;
  border: none;
  background: #2563eb;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.15s ease;
}

.firm-link-url button.copied {
  background: #16a34a;
}

.firm-link-preview {
  display: inline-flex;
  color: #2563eb;
  text-decoration: none;
  font-weight: 600;
}

.firm-link-preview:hover {
  text-decoration: underline;
}

.firm-link-actions {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 16px;
  flex-wrap: wrap;
}

.qr-code-btn {
  padding: 10px 20px;
  border-radius: 10px;
  border: 1px solid #2563eb;
  background: #ffffff;
  color: #2563eb;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
}

.qr-code-btn:hover:not(:disabled) {
  background: #2563eb;
  color: #ffffff;
}

.qr-code-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.qr-code-section {
  margin-top: 24px;
  padding: 20px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  text-align: center;
}

.qr-code-header h4 {
  margin: 0 0 4px 0;
  color: #0f172a;
  font-size: 18px;
}

.qr-code-header p {
  margin: 0 0 16px 0;
  color: #64748b;
  font-size: 14px;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
  padding: 16px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.qr-code-container img {
  max-width: 300px;
  width: 100%;
  height: auto;
  display: block;
}

.download-qr-btn {
  padding: 12px 24px;
  border-radius: 10px;
  border: none;
  background: #2563eb;
  color: #ffffff;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: background 0.2s ease;
  margin-top: 16px;
}

.download-qr-btn:hover {
  background: #1d4ed8;
}

@media (max-width: 768px) {
  .firm-link-actions {
    flex-direction: column;
    align-items: flex-start;
  }

  .qr-code-container img {
    max-width: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/InitialConsultation.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,wBAAwB;EACxB,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,eAAe;IACf,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;;IAEE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,MAAM;EACR;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe,EAAE,wBAAwB;IACzC,eAAe,EAAE,yBAAyB;EAC5C;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* InitialConsultation.css - Tabbed consultation interface */\n\n.initial-consultation {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n/* Header Section */\n.consultation-header {\n  margin-bottom: 20px;\n}\n\n.consultation-header h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0 0 8px 0;\n}\n\n.consultation-header p {\n  color: #6b7280;\n  margin: 0 0 16px 0;\n}\n\n.usage-info {\n  background: #f3f4f6;\n  padding: 8px 16px;\n  border-radius: 6px;\n  display: inline-block;\n}\n\n.usage-text {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.usage-text.limit-reached {\n  color: #dc2626;\n}\n\n/* Tab Navigation */\n.tab-navigation {\n  display: flex;\n  border-bottom: 2px solid #e5e7eb;\n  margin-bottom: 20px;\n}\n\n.tab-button {\n  background: none;\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s;\n}\n\n.tab-button:hover {\n  color: #374151;\n  background: #f9fafb;\n}\n\n.tab-button.active {\n  color: #4f46e5;\n  border-bottom-color: #4f46e5;\n  background: #f9fafb;\n}\n\n/* Forms Controls */\n.forms-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 16px;\n  background: #f9fafb;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.controls-left {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.controls-right {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.filter-section,\n.search-section,\n.slider-section {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-section label,\n.slider-section label {\n  font-weight: 500;\n  color: #374151;\n  font-size: 14px;\n}\n\n.filter-section select,\n.search-section input {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.search-section input {\n  width: 250px;\n}\n\n.slider-section input[type=\"range\"] {\n  width: 120px;\n}\n\n.create-form-btn {\n  background: #4f46e5;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.create-form-btn:hover:not(.disabled) {\n  background: #4338ca;\n}\n\n.create-form-btn.disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Forms List */\n.forms-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.form-list-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  margin-bottom: 8px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.form-list-item:hover {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-color: #d1d5db;\n}\n\n.form-list-item span {\n  font-size: 16px;\n  color: #374151;\n  font-weight: 500;\n}\n\n.view-details-btn {\n  background: #10b981;\n  color: white;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.view-details-btn:hover {\n  background: #059669;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.empty-icon {\n  font-size: 3rem;\n  margin-bottom: 16px;\n}\n\n.empty-state h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 8px 0;\n}\n\n.empty-state p {\n  color: #6b7280;\n  margin: 0 0 24px 0;\n}\n\n.create-btn {\n  background: #4f46e5;\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.create-btn:hover {\n  background: #4338ca;\n}\n\n/* Modal Form Styling */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.resume-textarea {\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 14px;\n  line-height: 1.5;\n  resize: vertical;\n  min-height: 200px;\n}\n\n.form-group small {\n  display: block;\n  margin-top: 5px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Consultation Modal - Wide Layout */\n.consultation-modal {\n  max-width: 650px !important;\n  width: 90% !important;\n  min-width: 550px;\n}\n\n.consultation-modal .modal-body {\n  padding: 32px;\n}\n\n.consultation-modal .form-creation-content {\n  width: 100% !important;\n}\n\n.consultation-modal form {\n  display: flex !important;\n  flex-direction: column !important;\n  width: 100% !important;\n  margin-bottom: 0 !important;\n  gap: 0 !important;\n}\n\n.consultation-modal .form-group {\n  margin-bottom: 24px;\n  width: 100%;\n}\n\n.consultation-modal .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.consultation-modal .form-group input,\n.consultation-modal .form-group select {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.consultation-modal .form-group input:focus,\n.consultation-modal .form-group select:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.consultation-modal .form-group input:hover,\n.consultation-modal .form-group select:hover {\n  border-color: #9ca3af;\n}\n\n.consultation-modal .form-help {\n  display: block;\n  margin-top: 6px;\n  color: #6b7280;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n/* Modal Form Actions */\n.consultation-modal .form-actions {\n  display: flex !important;\n  gap: 16px;\n  justify-content: flex-end !important;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #e5e7eb;\n  flex-direction: row !important;\n  width: 100% !important;\n}\n\n/* Polished View Details Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.modal {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: hidden;\n  animation: slideInUp 0.3s ease-out;\n  position: relative;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.close-btn-alt {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: #f3f4f6;\n  border: 2px solid #e5e7eb;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 20px;\n  font-weight: bold;\n  color: #6b7280;\n  transition: all 0.2s ease;\n  z-index: 100;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.close-btn-alt:hover {\n  background: #ef4444;\n  color: white;\n  border-color: #dc2626;\n  transform: scale(1.1);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n.form-card {\n  padding: 0;\n  background: white;\n}\n\n.form-header {\n  padding: 24px 24px 16px 24px;\n  border-bottom: 1px solid #f3f4f6;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n.form-header h3 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0 0 8px 0;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.form-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-status:before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  margin-right: 8px;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.form-details {\n  padding: 24px;\n  background: white;\n}\n\n.form-details p {\n  margin: 0 0 16px 0;\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.form-details p:last-child {\n  margin-bottom: 0;\n}\n\n.form-details strong {\n  color: #374151;\n  font-weight: 600;\n  min-width: 80px;\n  margin-right: 12px;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-details span {\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.form-actions {\n  padding: 20px 24px 24px 24px;\n  background: #f8fafc;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.copy-link-btn,\n.view-submissions-btn,\n.expire-btn {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 120px;\n  justify-content: center;\n}\n\n.copy-link-btn {\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  color: white;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.copy-link-btn:hover {\n  background: linear-gradient(135deg, #2563eb, #1e40af);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);\n}\n\n.view-submissions-btn {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.view-submissions-btn:hover {\n  background: linear-gradient(135deg, #059669, #047857);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);\n}\n\n.expire-btn {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: white;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n.expire-btn:hover {\n  background: linear-gradient(135deg, #dc2626, #b91c1c);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4);\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .modal {\n    width: 95%;\n    max-width: none;\n    margin: 20px;\n  }\n  \n  .form-header {\n    padding: 20px 20px 16px 20px;\n  }\n  \n  .form-header h3 {\n    font-size: 18px;\n    padding-right: 40px;\n  }\n  \n  .form-details {\n    padding: 20px;\n  }\n  \n  .form-details p {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n  \n  .form-details strong {\n    min-width: auto;\n    margin-right: 0;\n    font-size: 13px;\n  }\n  \n  .form-actions {\n    padding: 16px 20px 20px 20px;\n    flex-direction: column;\n  }\n  \n  .copy-link-btn,\n  .view-submissions-btn,\n  .expire-btn {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n.btn-primary,\n.btn-secondary {\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.consultation-modal .btn-primary {\n  background: #10b981 !important;\n  color: white !important;\n  border: none !important;\n}\n\n.consultation-modal .btn-primary:hover {\n  background: #059669 !important;\n}\n\n.btn-secondary {\n  background: white;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.btn-secondary:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .consultation-controls {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n  \n  .controls-left,\n  .controls-right {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .search-section input {\n    width: 100%;\n  }\n  \n  .forms-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n  \n  .initial-consultation {\n    padding: 10px;\n  }\n  \n  .consultation-modal .form-actions {\n    flex-direction: column !important;\n  }\n  \n  .consultation-modal {\n    min-width: auto !important;\n    width: 95% !important;\n    max-width: 95% !important;\n  }\n  \n  .consultation-modal .modal-body {\n    padding: 20px;\n  }\n  \n  .consultation-modal .form-group {\n    margin-bottom: 20px;\n  }\n  \n  .consultation-modal .form-group input,\n  .consultation-modal .form-group select {\n    font-size: 16px; /* Prevent zoom on iOS */\n    max-width: 100%; /* Full width on mobile */\n  }\n}\n\n.initial-consultation__firm-link {\n  margin-top: 32px;\n}\n\n.firm-link-card {\n  border-radius: 16px;\n  background: #ffffff;\n  padding: 20px 24px;\n  box-shadow: 0 12px 40px -20px rgba(15, 23, 42, 0.4);\n}\n\n.firm-link-header h3 {\n  margin: 0;\n  color: #0f172a;\n}\n\n.firm-link-header p {\n  margin: 6px 0 18px;\n  color: #475569;\n}\n\n.firm-link-loading,\n.firm-link-error {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #475569;\n}\n\n.firm-link-url {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.firm-link-url input {\n  flex: 1;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #cbd5f5;\n  background: #f8fafc;\n}\n\n.firm-link-url button {\n  padding: 10px 16px;\n  border-radius: 10px;\n  border: none;\n  background: #2563eb;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.firm-link-url button.copied {\n  background: #16a34a;\n}\n\n.firm-link-preview {\n  display: inline-flex;\n  color: #2563eb;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.firm-link-preview:hover {\n  text-decoration: underline;\n}\n\n.firm-link-actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-top: 16px;\n  flex-wrap: wrap;\n}\n\n.qr-code-btn {\n  padding: 10px 20px;\n  border-radius: 10px;\n  border: 1px solid #2563eb;\n  background: #ffffff;\n  color: #2563eb;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.qr-code-btn:hover:not(:disabled) {\n  background: #2563eb;\n  color: #ffffff;\n}\n\n.qr-code-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.qr-code-section {\n  margin-top: 24px;\n  padding: 20px;\n  border-radius: 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  text-align: center;\n}\n\n.qr-code-header h4 {\n  margin: 0 0 4px 0;\n  color: #0f172a;\n  font-size: 18px;\n}\n\n.qr-code-header p {\n  margin: 0 0 16px 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.qr-code-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 16px 0;\n  padding: 16px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.qr-code-container img {\n  max-width: 300px;\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.download-qr-btn {\n  padding: 12px 24px;\n  border-radius: 10px;\n  border: none;\n  background: #2563eb;\n  color: #ffffff;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: background 0.2s ease;\n  margin-top: 16px;\n}\n\n.download-qr-btn:hover {\n  background: #1d4ed8;\n}\n\n@media (max-width: 768px) {\n  .firm-link-actions {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .qr-code-container img {\n    max-width: 250px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
